import React, { Dispatch, SetStateAction } from 'react';
import { Button, Modal } from '@ixicare/ui';
import { t } from '~i18n';

interface DeletePlaneConfirmationModalProps {
  onDelete: (uuid: string) => void;
  loading: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  planeUuid: string;
}

const DeletePlaneConfirmationModal: React.FC<DeletePlaneConfirmationModalProps> = ({
  onDelete,
  loading,
  setShowModal,
  planeUuid,
}) => {
  if (!setShowModal) {
    return null;
  }
  return (
    <Modal style={{ maxWidth: 450 }}>
      <h3 className="text-center mb-30">{t('siteSettings.deletePlaneModal.description')}</h3>
      <Button
        className="mb-15 error"
        type="button"
        disabled={loading}
        loading={loading}
        isBlock
        buttonType="error"
        onClick={() => onDelete(planeUuid)}
      >
        {t('siteSettings.deletePlaneModal.delete')}
      </Button>
      <Button onClick={() => setShowModal(false)} disabled={loading} isBlock buttonType="link">
        {t('global.cancel')}
      </Button>
    </Modal>
  );
};

export default DeletePlaneConfirmationModal;
